module.exports = AFRAME;


//////////////////
// WEBPACK FOOTER
// external "AFRAME"
// module id = 4
// module chunks = 0